// Hebrew vocabulary for target periods.
//
// LABELS ONLY — deliberately no period-key arithmetic. Working out "the next
// period" needs week-year logic (a 53-week year rolls W52 → W53, not to the next
// January), and that lives in exactly one place: server/lib/targetPeriod.js.
// The client asks for it by name instead, via apply_to: 'next_forward'.

const NOUNS = {
  // `unit` is the bare noun, for sentences that inflect it themselves
  // ("יעד נקבע לחודש שלם" / "אינו שבוע בודד").
  // `plural` for counting ("חודשים שאין להם יעד"), `ofYear` for the whole
  // year's worth ("כל חודשי השנה").
  month: { thisOne: 'החודש הזה', nextOne: 'החודש הבא', adjective: 'חודשי', view: 'חודשית', unit: 'חודש',
           plural: 'חודשים', ofYear: 'חודשי השנה' },
  week:  { thisOne: 'השבוע הזה', nextOne: 'השבוע הבא', adjective: 'שבועי', view: 'שבועית', unit: 'שבוע',
           plural: 'שבועות', ofYear: 'שבועות השנה' },
};

export const periodNoun = (period) => NOUNS[period] || NOUNS.month;

// 'YYYYMM' → 'אוגוסט 2026'; 'YYYY-Www' → 'שבוע 32, 2026'.
// Display only — never parsed back.
const MONTHS = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני',
                'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];

export function periodKeyLabel(periodKey, period) {
  if (!periodKey) return '';
  if (period === 'week') {
    return `שבוע ${parseInt(periodKey.slice(6), 10)}, ${periodKey.slice(0, 4)}`;
  }
  const month = parseInt(periodKey.slice(4), 10);
  return `${MONTHS[month - 1] || ''} ${periodKey.slice(0, 4)}`.trim();
}
